import { merge } from 'lodash';

import { BaseController } from '@shared/basecontroller.controller';
import { SearchFormModel } from '../model/searchform.model';

class SearchFormController extends BaseController {
  constructor(BetOverviewApiService, FormService) {
    'ngInject';

    super();

    this.BetOverviewApiService = BetOverviewApiService;
    this.FormService = FormService;
  }

  $onInit() {
    this.form = new SearchFormModel();
    let payload = this.form.toPayload(); 

    this.BetOverviewApiService.getLeagues().then(leagues => this.form.leagues = leagues);
    this.BetOverviewApiService.getBetOverview(payload).then(betoverview => this.onFetchBetOverview({betoverview : betoverview, payload: payload}));
  }

  submit() {
    this.FormService.isSubmitting.next(true);
    
    let payload = this.form.toPayload();
    let searchform = this.FormService.evaluateForms()['searchform'];

    let mergedPayload = merge(payload, {
      betTypeText: searchform.betType.text,
      leagueText: searchform.league.text,
    });

    this.BetOverviewApiService.getBetOverview(payload).then((betoverview) => {
      this.onFetchBetOverview({betoverview : betoverview, payload: mergedPayload});
      this.FormService.isSubmitting.next(false);
    });
  }

  onBetTypeChange() {
    this.form.props.betSelection.readOnly = false;

    this.form.betSelectionSelect.resetProperties();
    this.form.betTypeSelect.resetProperties();

    let betTypeSelectChangeBehavior = {
      '1X2': () => {
        this.form.betSelectionSelect.setProperty('Under', 'disabled', true);
        this.form.betSelectionSelect.setProperty('Over', 'disabled', true);
      },
      'AHDP': () => {
        this.form.betSelectionSelect.setProperty('Under', 'disabled', true);
        this.form.betSelectionSelect.setProperty('Over', 'disabled', true);
        this.form.betSelectionSelect.setProperty('Draw', 'disabled', true);
      },
      'O/U': () => {
        this.form.betSelectionSelect.setProperty('Home', 'disabled', true);
        this.form.betSelectionSelect.setProperty('Away', 'disabled', true);
        this.form.betSelectionSelect.setProperty('Draw', 'disabled', true);
      },
      'Special/Multiple': () => {
        this.form.props.betSelection.readOnly = true;
      },
      '': () => {
        this.form.betSelection = '';
        this.form.props.betSelection.readOnly = true;
      }
    };

    betTypeSelectChangeBehavior[this.form.betType]();
  }

  onBetSelectionChange() {
    this.form.betSelectionSelect.resetProperties();
    this.form.betTypeSelect.resetProperties();

    let betSelectionChangeBehavior = {
      'Draw': () => {
        this.form.betTypeSelect.setProperty('AHDP', 'disabled', true);
        this.form.betTypeSelect.setProperty('O/U', 'disabled', true);
        this.form.betTypeSelect.setProperty('SPECIAL/MULTIPLE', 'disabled', true);
      },
      'Home': () => {
        this.form.betTypeSelect.setProperty('O/U', 'disabled', true);
        this.form.betTypeSelect.setProperty('SPECIAL/MULTIPLE', 'disabled', true);
      },
      'Away': () => {
        this.form.betTypeSelect.setProperty('O/U', 'disabled', true);
        this.form.betTypeSelect.setProperty('SPECIAL/MULTIPLE', 'disabled', true);
      },
      'Under': () => {
        this.form.betTypeSelect.setProperty('1X2', 'disabled', true);
        this.form.betTypeSelect.setProperty('AHDP', 'disabled', true);
        this.form.betTypeSelect.setProperty('SPECIAL/MULTIPLE', 'disabled', true);
      },
      'Over': () => {
        this.form.betTypeSelect.setProperty('1X2', 'disabled', true);
        this.form.betTypeSelect.setProperty('AHDP', 'disabled', true);
        this.form.betTypeSelect.setProperty('SPECIAL/MULTIPLE', 'disabled', true);
      }
    };

    betSelectionChangeBehavior[this.form.betSelection]();
  }

  reset() {
    this.form.reset();
  }
}

export default SearchFormController;


// WEBPACK FOOTER //
// ./client/app/pages/customer/betoverview/component/overview/component/searchform.controller.js